import { DEFINITIONS_BASE_PATH } from './definitions-base-path.js';

const base = `${DEFINITIONS_BASE_PATH}/organization`;

export const generalSystemTabsConfig = {
  basePath: base,
  tabs: [
    {
      id: "units",
      path: `${base}/units`,
      pageKey: "definitionsGeneralSystemUnit",
    },
    {
      id: "process",
      path: `${base}/process`,
      pageKey: "definitionsGeneralSystemProcess",
    },
    {
      id: "team",
      path: `${base}/team`,
      pageKey: "definitionsGeneralSystemTeam",
    },
    {
      id: "duty-definitions",
      path: `${base}/duty-definitions`,
      pageKey: "definitionsGeneralSystemDutyDefinition",
    },
    {
      id: "root-cause",
      path: `${base}/root-cause`,
      pageKey: "definitionsGeneralSystemRootCause",
    },
  ],
};
